import { render, staticRenderFns } from "./OverviewCourseModules.vue?vue&type=template&id=6bf8a05f&scoped=true&"
import script from "./OverviewCourseModules.vue?vue&type=script&lang=js&"
export * from "./OverviewCourseModules.vue?vue&type=script&lang=js&"
import style0 from "./OverviewCourseModules.vue?vue&type=style&index=0&id=6bf8a05f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf8a05f",
  null
  
)

export default component.exports